import axios from "axios";
import React, {useEffect, useRef, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import Select, {createFilter} from "react-select";
import {useTable} from "react-table";
import {getTerminalLocationByIDApi} from "../Api";
import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {CSVLink} from "react-csv";
import CustomOption from "../Utils/CustomOption";
import CustomMenuList from "../Utils/CustomMenuList";


function CashLoad(props) {
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
  const [terminalSelectData, setTerminalSelectData] = useState([]);
  const [selectedTerminal, setSelectedTerminal] = useState();
  const [data, setData] = useState([]);
  const history = useHistory();
  const location = useLocation();
  const [filterValue, setFilterValue] = useState("terminalID");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [locationOptions, setLocationOptions] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState();
  const [isTableVisible, setIsTableVisible] = useState(false);
  const rowsRef = useRef();


  const columns = [
    {
      Header: "Replenishment Date",
      accessor: "replenishmentDate",
    },
    {
      Header: "Cassette",
      accessor: "Cassette",
    },
    {
      Header: "Media",
      accessor: "Media",
    },
    {
      Header: "Currency",
      accessor: "Currency",
    },
    {
      Header: "Load Count",
      accessor: "loadCount",
    },
    {
      Header: "Load Amount",
      accessor: "loadAmount",
    },
  ];

  function Table({ columns, data }) {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
      useTable({
        columns,
        data,
      });
    rowsRef.current = rows;
    return (
      <>
        <div className="report_table_outer">
          <div className="table-responsive">
            <table {...getTableProps()} className="table table-bordered  small">
              <thead className="thead-light">
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th {...column.getHeaderProps()}>
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map((row, i) => {
                  prepareRow(row);
                  return (
                    <tr
                      {...row.getRowProps()}
                      // onClick={() => console.log(row.original)}
                    >
                      {row.cells.map((cell) => {
                        return (
                          <td {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  }
  const exportPDF = () => {
    const unit = "pt";
    const size = "A4";
    const orientation = "portrait";

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const title = "My Awesome Report";
    const headers = [
      [
        "replenishmentDate",
        "Cassette",
        "Media",
        "Currency",
        "loadCount",
        "loadAmount",
      ],
    ];

    const pdata = data?.map((elt) => [...Object.values(elt)]);

    let content = {
      startY: 50,
      head: headers,
      body: pdata,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("report.pdf");
  };

  useEffect(() => {
    props?.terminalsData?.map((item, index) => {
      setTerminalSelectData((options) => [
        ...options,
        { label: item.terminalID, value: item.terminalID },
      ]);
    });

    const terminalId = location?.search?.split("=")?.[1];
    setSelectedTerminal({ label: terminalId, value: terminalId });
    const getLocations = async () => {
      const result = await axios.get(`${getTerminalLocationByIDApi}?paramUserID=${loggedUserStorage}&paramByType=LOCATION&paramSearchCriteria=`);
      /**console.log(" locations ",result?.data)*/
     /* result?.data?.response.map((item, index) =>
        setLocationOptions((old) => [
          ...old,
          { label: item.location, value: item.terminalID },
        ])
      );*/



        setLocationOptions(result?.data);
      setSelectedLocation(locationOptions?.[0]);
    };
    getLocations();
    return () => {
      setData([]);
      setTerminalSelectData([]);
      setLocationOptions([]);
    };
  }, [location]);

  const handleGetReport = async () => {
      if(typeof startDate === 'undefined'){
          alert("Please provide Start Date");
          return false
      }else if(typeof endDate === 'undefined'){
          alert("Please provide End Date");
          return false
      }
    try {
        let filterResult;
        {filterResult = filterValue == "terminalID" ? selectedTerminal.value :selectedLocation.value}

      const result = await axios.get(
        "getTerminalCashLoadInfo?pTerminalID=" +
          filterResult +
          "&pStartDate=" +
          startDate +
          "&pEndDate=" +
          endDate
      );
      setIsTableVisible(true);
    } catch (error) {}
  };


  return (
    <div>
      <div className="row mt-3">
        <div className="col col-md-5">
          <div className="d-flex justify-content-between">
            <label>Start Date:</label>
            <div>
              <input
                type="date"
                class="form-control"
                style={{ width: "12.5vw" }}
                onChange={(e) =>
                  setStartDate(
                    moment(e.target.value).format("YYYY-MM-DD HH:mm:ss")
                  )
                }
              />
            </div>
          </div>
        </div>
        <div className="col col-md-1"></div>
        <div className="col col-md-5">
          <div className="d-flex justify-content-between">
            <label>End Date:</label>
            <div>
              <input
                type="date"
                class="form-control"
                style={{ width: "12.5vw" }}
                onChange={(e) =>
                  setEndDate(
                    moment(e.target.value).format("YYYY-MM-DD HH:mm:ss")
                  )
                }
              />
            </div>
          </div>
        </div>
      </div>
      {/*  */}
      <div className="row mt-3 d-flex align-items-center">
        <div className="col col-md-5">
          {filterValue == "terminalID" ? (
            <div className="d-flex justify-content-between align-items-center">
              <label>Terminal ID:</label>
              <div>
                  {/*<Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={terminalSelectData}
                      value={selectedTerminal}
                      onChange={(e) => setSelectedTerminal(e)}
                      sx={{ width: 300 }}
                      renderInput={(params) => <TextField {...params} label="Movie" />}
                  />*/}
                <Select
                  options={terminalSelectData}
                  value={selectedTerminal}
                  onChange={(e) => setSelectedTerminal(e)}
                  filterOption={createFilter({ ignoreAccents: false })}
                  captureMenuScroll={false}
                  classNamePrefix="custom-select"
                  components={{ Option: CustomOption, MenuList: CustomMenuList }}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      flex: 1,
                      width: "12.5vw",
                    }),
                  }}
                />
              </div>
            </div>
          ) : (
            <div className="d-flex justify-content-between align-items-center">
              <label>Location:</label>
              <div>
                <Select
                  options={locationOptions}
                  value={selectedLocation}
                  onChange={(e) => setSelectedLocation(e)}
                  filterOption={createFilter({ ignoreAccents: false })}
                  captureMenuScroll={false}
                  classNamePrefix="custom-select"
                  components={{ Option: CustomOption, MenuList: CustomMenuList }}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      flex: 1,
                      width: "12.5vw",
                    }),
                  }}
                />
              </div>
            </div>
          )}
        </div>
        <div className="col col-md-1"></div>
        <div
          className="col col-md-5"
          onChange={(e) => setFilterValue(e.target.value)}
        >
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="filter"
              value="terminalID"
              id="terminalID"
              checked={filterValue == "terminalID" ? true : false}
            />
            <label class="form-check-label" htmlFor="terminalID">
              terminalID
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="filter"
              value="location"
              id="location"
              checked={filterValue == "location" ? true : false}
            />
            <label class="form-check-label" htmlFor="location">
              location
            </label>
          </div>
        </div>
      </div>
      {/*  */}
      <div className="row d-flex justify-content-center mt-4 align-items-center">
        <span
          class="input-group-text"
          role="button"
          onClick={() => handleGetReport()}
        >
          Get Report
        </span>
        <span class="input-group-text ml-4" role="button" onClick={() => {}}>
          <CSVLink
            data={data}
            style={{ color: "inherit", textDecoration: "inherit" }}
          >
            Export to Excel
          </CSVLink>
        </span>
        <span
          class="input-group-text ml-4"
          role="button"
          onClick={() => {
            exportPDF();
          }}
        >
          Export to PDF
        </span>
      </div>
      {/*  */}
      <div className="mt-3">
        {isTableVisible && <Table columns={columns} data={data} />}
      </div>
    </div>
  );
}

export default CashLoad;
